import { Droplet, FlaskConical, Trash2, TrendingUp, Zap } from "lucide-react";
import { FaLeaf } from "react-icons/fa";
import { MdAgriculture, MdBackpack } from "react-icons/md";
import { ProOptions } from "reactflow";
import { images } from "../assets/images";
import { getCompanyLogo } from "../utils/utils";
import { IngredientDataTypesOption, RecipeDataTypesOption } from "./enums/IngredientType.enum";
import { MappingSourceType } from "./enums/MappingSourceType.enum";
import { StorageEnvType } from "./enums/StorageType.enum";

const API_URL = process.env.REACT_APP_API_URL;

const NP_API_URL = process.env.REACT_APP_NP_API_URL;

const NP_SOCKET_API_URL = process.env.REACT_APP_NP_SOCKET_API_URL;

const WEB_VERSION = process.env.REACT_APP_VERSION;

const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

const NP_CALCULATOR_API_URL = "https://r99sbn0ct4.execute-api.eu-north-1.amazonaws.com/stage";

const MAPBOX_BASE_API_URL = "https://api.mapbox.com/search/geocode/v6";

const MAPBOX_V5_API_URL = "https://api.mapbox.com/geocoding/v5";

const drawerRoute = ["/drawer", "/drawing-ingredient"];

const DISABLE_CLOSE_MODEL_ID = ["6", "8", "10", "11"];

const COMMON_PROTECT_ROUTE_PATH = "/auth";

const EMAIL_ADDRESS = "hello@naturepreserve.co";

const NOT_APPLICABLE = "N/A";

const FEATURE_FLAGS = JSON.parse(process.env.REACT_APP_FEATURE_FLAGS || "{}");

const ImpactAssessmentMethodText =
  "´s impact assessment methodology strictly adheres to ISO 14040:2006 and ISO 14044:2006 standards for Life Cycle Assessment.";

// Alfa Laval for BLUE theme.
// Nature Preserve for GREEN theme.
const THEME = process.env.REACT_APP_THEME;
const COMPANY_LOGO = getCompanyLogo(THEME);
const COMPANY_NAME = process.env.REACT_APP_COMPANY_NAME;
const proOptionsForReactFlow: ProOptions = {
  // account: "bs@naturepreserve.co",
  hideAttribution: true
};
const DISABLE_RECIPE_SIMULATOR = FEATURE_FLAGS.DisableRecipeSimulator;
const DISABLE_BEST_PRACTICE = FEATURE_FLAGS.DisableBestPractice;

const MENU_SIDE_BAR = [
  {
    mainTitle: "",
    subTitle: [
      {
        name: "dashboard",
        titleName: "Dashboard",
        path: "/",
        icon: images.Dashboard,
        activeIcon: images.LightDashboard
      },
      {
        name: "product",
        titleName: "Products",
        path: "/product",
        icon: images.ProductImage,
        activeIcon: images.LightProductImage
      },
      {
        name: "ingredient",
        titleName: "Ingredients",
        path: "/ingredient",
        icon: images.IngredientImage,
        activeIcon: images.LightIngredientImage
      },
      {
        name: "supplier",
        titleName: "Suppliers",
        path: "/supplier",
        icon: images.SupplierImage,
        activeIcon: images.LightSupplierImage
      },
      {
        name: "facility",
        titleName: "Facilities",
        path: "/facility",
        icon: images.transportImage,
        activeIcon: images.LightTransportImage
      },
      {
        name: "mapping",
        titleName: "Mapping Tool",
        path: `/mapping/${MappingSourceType.product}`,
        icon: images.IngredientSummery,
        activeIcon: images.LightIngredientSummery
      },
      {
        name: "recipeSimulator",
        titleName: "Recipe Simulator",
        path: "/recipe-simulator",
        isHidden: DISABLE_RECIPE_SIMULATOR
      },
      {
        name: "drawingIngredient",
        titleName: "Ingredient Mapping",
        path: "/drawing/drawing-ingredient",
        icon: images.IngredientSummery,
        activeIcon: images.LightIngredientSummery
      },
      {
        name: "productSummary",
        titleName: "Product Summary",
        path: "/product-summary",
        icon: images.productSummery,
        activeIcon: images.LightProductSummery
      },
      {
        name: "clientList",
        titleName: "Client List",
        path: "/client-list",
        icon: images.ClientImage,
        activeIcon: images.LightClientImage
      },
      {
        name: "drawingRequests",
        titleName: "Data Requests",
        path: "/mapping-interaction",
        icon: images.Notification,
        activeIcon: images.Notification
      }
    ]
  }
];

const HEADER_MENU_BAR = [
  {
    key: "1",
    text: "Company",
    value: "company",
    path: "/company"
  },
  {
    key: "2",
    text: "Users",
    value: "user",
    path: "/users"
  },
  {
    key: "3",
    text: "Static Config",
    value: "staticConfiguration",
    path: "/settings/static-configuration"
  },
  {
    key: "4",
    text: "Supplier Request",
    value: "staticConfiguration",
    path: "/supplierRequest"
  }
];

const ProductFilterData = [
  { key: Math.random(), text: "All", value: "All" },
  { key: Math.random(), text: "Farm Product", value: "Farm Product" },
  { key: Math.random(), text: "Processed", value: "Processed" },
  { key: Math.random(), text: "Custom/Filter", value: "Custom/Filter" }
];

const UserFilterData = [
  { key: Math.random(), text: "All", value: "All", skip: false },
  {
    key: Math.random(),
    text: "Super Admin",
    value: "Farm Product",
    skip: false
  },
  { key: Math.random(), text: "Admin", value: "Processed", skip: false }
];

const HarvestSeasonData = [
  { key: Math.random(), text: "Unknown", value: "Unknown" },
  { key: Math.random(), text: "Spring", value: "Spring" },
  { key: Math.random(), text: "Summer", value: "Summer" },
  { key: Math.random(), text: "Fall", value: "Fall" },
  { key: Math.random(), text: "Winter", value: "Winter" }
];

const FertilizerNameData = [
  { key: 1, text: "Manure-General", value: "Manure-General", name: "general" },
  { key: 2, text: "Manure-Cattle", value: "Manure-Cattle", name: "cattle" },
  { key: 3, text: "Manure-Poultry", value: "Manure-Poultry", name: "poultry" },
  { key: 4, text: "Manure-Pig", value: "Manure-Pig", name: "pig" },
  { key: 5, text: "Nitrogen (N)", value: "Nitrogen (N)", name: "nitrogen" },
  {
    key: 6,
    text: "Phosphorus (P)",
    value: "Phosphorus (P)",
    name: "phosphorus"
  },
  { key: 7, text: "Potassium (K)", value: "Potassium (K)", name: "potassium" }
];
const SipContents = [
  {
    name: "Manufacturer",
    value: "",
    unit: "None",
    typeName: "manufacturer"
  },
  {
    name: "Model Number",
    value: "",
    unit: "None",
    typeName: "modelNumber"
  },
  {
    name: "Energy Consumption",
    value: "",
    unit: "kWh",
    typeName: "energyConsumption"
  },
  {
    name: "Steam Pressure",
    value: "",
    unit: "bar",
    typeName: "steamPressure"
  },
  {
    name: "Steam Flow",
    value: "",
    unit: "kg/hr",
    typeName: "steamFlow"
  },

  {
    name: "Water Consumption",
    value: "",
    unit: "L",
    typeName: "waterConsumption"
  },
  {
    name: "Waste water",
    value: "",
    unit: "L",
    typeName: "wasteWater"
  },
  {
    name: "Hydrogen Peroxide Concentration",
    value: "",
    unit: "%",
    typeName: "hydrogenPeroxideConcentration"
  },
  {
    name: "Hydrogen Peroxide Consumption",
    value: "",
    unit: "L per round",
    typeName: "hydrogenPeroxideConsumption"
  },
  {
    name: "Caustic Soda Concentration",
    value: "",
    unit: "%",
    typeName: "causticSodaConcentration"
  },
  {
    name: "Caustic Soda Consumption",
    value: "",
    unit: "L per round",
    typeName: "causticSodaConsumption"
  }
];

const ProductTableContent = [
  {
    name: {
      id: "122"
    },
    climate: 3,
    reg: 123
  },
  {
    name: "Name",
    climate: 3,
    reg: 123
  },
  {
    name: "Name",
    climate: 3,
    reg: 123
  },
  {
    name: "Name",
    climate: 3,
    reg: 123
  }
];

const switchSize = {
  mini: "mini",
  tiny: "tiny",
  small: "small",
  medium: "medium",
  large: "large",
  big: "big",
  huge: "huge",
  massive: "massive"
};

const packagingFieldMap = {
  singleUnitPackaging: "single-unit",
  salesUnitPackaging: "sales-unit",
  bulkUnitPackaging: "bulk-unit",
  transportUnitPackaging: "transport-unit"
};

const CycleStage = [
  {
    title: "Agriculture",
    icon: MdAgriculture
  },
  {
    title: "Transformation",
    icon: FaLeaf
  },
  {
    title: "Transformation",
    icon: MdBackpack
  },
  {
    title: "Transformation",
    icon: MdAgriculture
  }
];

const IngredientImpact = [
  {
    title: "Milk"
  },
  {
    title: "Strawberry"
  },
  {
    title: "White Suger"
  },
  {
    title: "Other Steps"
  }
];

const ProductSummaryButtonAverageProduct = [
  {
    text: "Ingredient Impact",
    skip: true
  },
  {
    text: "Supply Chain Overview",
    skip: true
  },
  {
    text: "KPI",
    skip: true
  },
  {
    text: "Impact Reduction",
    skip: true
  },
  {
    text: "Reports",
    skip: true
  },
  {
    text: "Certificates",
    skip: true
  },
  {
    text: "Product Mapping",
    skip: false
  },
  {
    text: "Product Simulation - Beta",
    skip: false
  },
  {
    text: "Packaging Simulation",
    skip: true
  },
  {
    text: "Product History",
    skip: true
  }
];

const ProductSummaryTitle = [
  {
    id: 1,
    text: "Ingredient Impact",
    skip: true
  },
  {
    id: 2,
    text: "Supply Chain Overview",
    skip: true
  },
  {
    id: 3,
    text: "KPI",
    skip: true
  },
  {
    id: 4,
    text: "Impact Reduction",
    skip: true
  },
  {
    id: 5,
    text: "Reports",
    skip: true
  },
  {
    id: 6,
    text: "Certificates",
    skip: true
  },
  {
    id: 7,
    text: "Product Best Practice",
    skip: DISABLE_BEST_PRACTICE
  },
  {
    id: 8,
    text: "Product Mapping",
    skip: false
  },
  {
    id: 9,
    text: "Product Simulation - Beta",
    skip: false
  },
  {
    id: 10,
    text: "Packaging Simulation",
    skip: true
  },
  {
    id: 11,
    text: "Product History",
    skip: false
  }
];

const newNodes = [
  {
    id: "1",
    image: images.ingredients_icon,
    cardHeader: "Ingredients",
    cardExtra: "Ingredients types"
  },
  {
    id: "2",
    image: images.transport_icon,
    cardHeader: "Transportation",
    cardExtra: "Transportation by Flight"
  },
  {
    id: "3",
    image: images.process_icon,
    cardHeader: "Process",
    cardExtra: "Precessed Ingredients"
  },
  {
    id: "4",
    image: images.warehouse_icon,
    cardHeader: "Warehouse",
    cardExtra: "Ingredients types"
  },
  {
    id: "5",
    image: images.package_icon,
    cardHeader: "Packing",
    cardExtra: "Ingredients types"
  },
  {
    id: "6",
    image: images.client_icon,
    cardHeader: "Client",
    cardExtra: "Ingredients types"
  }
];

const NoteDocumentTable = [
  {
    name: "",
    col: 1
  },
  {
    name: "Document Name",
    col: 7
  },
  {
    name: "Upload on",
    col: 4
  },
  {
    name: "",
    col: 4
  }
];

const TransportTypeCol = [
  {
    name: "Transportation Type",
    col: 6
  },
  {
    name: "Distance",
    col: 6
  },
  {
    name: "",
    col: 4
  }
];

const TransportSimulateCol = [
  {
    name: "Chemical name",
    col: 4
  },
  {
    name: "Chemical Amount (kg/kg input)",
    col: 4
  },
  {
    name: "Transportation Type",
    col: 4
  },
  {
    name: "Distance",
    col: 4
  }
];

const WasteManagementDataCol = [
  {
    name: "Management Name",
    col: 4
  },
  {
    name: "Management Type",
    col: 4
  },
  {
    name: "Distribution (kg)",
    col: 4
  },
  {
    name: "",
    col: 4
  }
];

const DATA_TYPES = [
  { key: 0, text: "Provided by Supplier", value: "SUPPLIER" },
  { key: 1, text: "Generic", value: "GENERIC" },
  { key: 2, text: "Provided by User", value: "USER" }
];

const INGREDIENT_TYPE = [
  {
    key: 1,
    text: "RAW",
    value: "RAW"
  },
  {
    key: 2,
    text: "PROCESSED",
    value: "PROCESSED"
  }
];

const ENERGY_UNIT_TYPE = [
  {
    key: 1,
    text: "kWh",
    value: 1
  },
  {
    key: 2,
    text: "MJ",
    value: 2
  },
  {
    key: 3,
    text: "thm",
    value: 3
  },
  {
    key: 4,
    text: "btu",
    value: 4
  }
];

const PER_TYPES = [
  {
    key: "day",
    text: "day",
    value: "day"
  },
  {
    key: "week",
    text: "week",
    value: "week"
  },
  {
    key: "month",
    text: "month",
    value: "month"
  },
  {
    key: "year",
    text: "year",
    value: "year"
  }
];

const PER_WEIGHT_UNITS = [
  {
    key: "kg",
    text: "kg",
    value: "kg"
  },
  {
    key: "ton",
    text: "ton",
    value: "ton"
  }
];

const NotificationTableCok = [
  {
    name: "Title",
    col: 6
  },
  {
    name: "Description",
    col: 6
  },
  {
    name: "Date",
    col: 4
  }
];

const SupplierRequestStatus = {
  Requested: 1,
  Accepted: 2,
  InProgress: 3,
  Completed: 4,
  Updated: 5
};

const SimulationImpactFarm = [
  { key: "cultivations", name: "internalStorageName" },
  { key: "internalStorage", name: "internalStorageName" },
  { key: "internalTransportation", name: "internalTransportName" },
  { key: "packaging", name: "packingName" },
  { key: "processing", name: "processingName" }
];

const SimulationImpactProcess = [
  { key: "internalStorage", name: "internalStorageName" },
  { key: "internalTransportation", name: "internalTransportName" },
  { key: "packaging", name: "packingName" },
  { key: "processing", name: "processingName" }
];

const SimulationNetZeroDataTable = [
  {
    name: "",
    col: 1
  },
  {
    name: "Simulation Name",
    col: 1
  },
  {
    name: "Original Impact",
    col: 2
  },
  {
    name: "Simulated Impact",
    col: 2
  },
  {
    name: "Original Consumption Cost",
    col: 1
  },
  {
    name: "Simulated Consumption Cost",
    col: 1
  },
  {
    name: "Impact Change Impact %",
    col: 1
  },
  {
    name: "Detail",
    col: 3,
    textAlign: "center"
  },
  {
    name: "Net-zero journey",
    col: 1
  }
];

const SimulationDataTable = [
  {
    name: "Simulation Name",
    col: 4
  },
  {
    name: "Original Impact",
    col: 4
  },
  {
    name: "Simulated Impact",
    col: 4
  },
  // TODO:- Hide for demo
  // {
  //   name: "Step Impact Change %",
  //   col: 4,
  // },
  {
    name: "Impact Change Impact %",
    col: 4
  }
];

const PACKAGE_TYPES = ["base-unit", "sales-unit", "bulk-unit", "transport-unit"];

const MappingInteractionStatus: Record<number, string> = {
  1: "Requested",
  2: "Accepted",
  3: "InProgress",
  4: "Completed",
  5: "Updated",
  6: "Reminder"
};

const noResultIngredient = {
  id: 0,
  title: "+ New"
};

const newSupplier = {
  id: 0,
  title: "+ New"
};

const newChemical = {
  id: 0,
  title: "+ New"
};

const newSupplierId = 0;
const inHouseSupplierId = 1;
const customOptionSupplier = [newSupplierId, inHouseSupplierId];

const modelContentType = {
  view: 1,
  edit: 2
};
const customButtonUpdatetitle = "Update";

const modelContentUpdateType = {
  add: 1,
  delete: 2
};

const IngredientViewTabs = [
  { name: "Ingredient Summary", size: 4 },
  { name: "Environmental Footprint", size: 3 },
  { name: "Supply Chain Mapping", size: 3 },
  { name: "History", size: 3 },
  { name: "Volume And Cost", size: 3 }
  // { name: "Supplier Ingredients", size: 3 } //Future use this feature
];

const ChemicalViewTabs = [
  { name: "Chemical Summary", size: 4 },
  { name: "Environmental Footprint", size: 4 },
  { name: "History", size: 4 },
  { name: "Volume And Cost", size: 4 }
];

const ProductViewTabs = [
  { name: "Product Summary", size: 4 },
  { name: "Environmental Footprint", size: 4 },
  { name: "History", size: 4 },
  { name: "Volume And Cost", size: 4 }
];

const MappingReviewTabs = [
  { name: "Ingredient", id: 0 },
  { name: "Process gate", id: 1 },
  { name: "Farm gate", id: 2 },
  { name: "External transport", id: 3 },
  { name: "External storage", id: 4 }
];

const GateType = {
  FarmGate: "Farm Gate",
  ProcessGate: "Process Gate"
};

const FarmGateReviewTabs = [
  { name: "Cultivation", id: 0 },
  { name: "Process", id: 1 },
  { name: "Packaing", id: 2 },
  { name: "Transport", id: 3 },
  { name: "Storage", id: 4 }
];

const ProcessGateReviewTabs = [
  { name: "Process", id: 0 },
  { name: "Packaing", id: 1 },
  { name: "Transport", id: 2 },
  { name: "Storage", id: 3 }
];

const PRODUCT_TAB_KEYS = {
  SUMMARY: 0,
  ENVIRONMENTAL_FOOTPRINT: 1,
  HISTORY: 2,
  ANNUAL_VOLUME_AND_COST: 3
};

const TAB_KEYS = {
  SUMMARY: 0,
  ENVIRONMENTAL_FOOTPRINT: 1,
  SUPPLY_CHAIN_MAPPING: 2,
  HISTORY: 3,
  ANNUAL_VOLUME_AND_COST: 4,
  SUPLIER_INGREDIENTS: 5,
  SALES_VOLUMES: 6
};

const CHEMICAL_TAB_KEYS = {
  SUMMARY: 0,
  ENVIRONMENTAL_FOOTPRINT: 1,
  HISTORY: 2,
  ANNUAL_VOLUME_AND_COST: 3
};

const calculationStatus = ["Not Calculated", "Calculated", ""];

const LcalCulculationDefultValues = {
  acidification: { measure: 0, unit: "mol H+ eq" },
  climateChange: { measure: 0, unit: "kgCO2eq" },
  "ecotoxicity-freshWater": { measure: 0, unit: "CTUe" },
  "eutrophication-freshWater": { measure: 0, unit: "kg P eq" },
  "eutrophication-Marine": { measure: 0, unit: "kg N eq" },
  "eutrophication-Terrestrial": { measure: 0, unit: "mol N eq" },
  "humanToxicity-Cancer": { measure: 0, unit: "CTUh" },
  "humanToxicity-nonCancer": { measure: 0, unit: "CTUh" },
  ionisingRadiation: { measure: 0, unit: "kBq U-235 eq" },
  landUse: { measure: 0, unit: "Pt" },
  ozoneDepletion: { measure: 0, unit: "kg CFC11 eq" },
  particulateMatter: { measure: 0, unit: "disease inc." },
  photochemicalOzoneFormation: { measure: 0, unit: "kg NMVOC eq" },
  "resourceUse-Fossils": { measure: 0, unit: "MJ" },
  "resourceUse-MineralsAndMetals": { measure: 0, unit: "kg Sb eq" },
  waterUse: { measure: 0, unit: "m3 depriv." }
};

const SupplierClientRequestTab = [
  {
    id: 1,
    title: "Supplier Request",
    subtitle: "Request sent to suppliers"
  },
  {
    id: 2,
    title: "Client Requests",
    subtitle: "Request coming from clients"
  }
];

// Supplier default country
const SUPPLIER_DEFAULT_COUNTRY_GLOBAL = 0;
const DEFAULT_COUNTRY_CODE = "DK";

const CULTIVATION_TYPE = {
  Supplier: "Supplier",
  Generic: "Generic"
};
const IMPACT_CATEGORY = [
  { key: 1, text: "Acidification", value: "acidification" },
  { key: 2, text: "Climate Change Impact", value: "climateChange" },
  {
    key: 3,
    text: "Ecotoxicity - Fresh Water",
    value: "ecotoxicity-freshWater"
  },
  {
    key: 4,
    text: "Eutrophication - Fresh Water",
    value: "eutrophication-freshWater"
  },
  { key: 5, text: "Eutrophication - Marine", value: "eutrophication-Marine" },
  {
    key: 6,
    text: "Eutrophication - Terrestrial",
    value: "eutrophication-Terrestrial"
  },
  { key: 7, text: "Human Toxicity - Cancer", value: "humanToxicity-Cancer" },
  {
    key: 8,
    text: "Human Toxicity - Non-Cancer",
    value: "humanToxicity-nonCancer"
  },
  { key: 9, text: "Ionising Radiation", value: "ionisingRadiation" },
  { key: 10, text: "Land Use", value: "landUse" },
  { key: 11, text: "Ozone Depletion", value: "ozoneDepletion" },
  { key: 12, text: "Particulate Matter", value: "particulateMatter" },
  {
    key: 13,
    text: "Photochemical Ozone Formation",
    value: "photochemicalOzoneFormation"
  },
  { key: 14, text: "Resource Use - Fossils", value: "resourceUse-Fossils" },
  {
    key: 15,
    text: "Resource Use - Minerals & Metals",
    value: "resourceUse-MineralsAndMetals"
  },
  { key: 16, text: "Water Use", value: "waterUse" }
];

const NEW_FACILITY_KEY = "NEW_FACILITY";

const NewFacilityOption = {
  key: "NEW_FACILITY",
  value: "NEW_FACILITY",
  text: "+ New Facility",
  className: "new-facility-option"
};

const supplierOrderByOptions = [
  { key: "createdAtDesc", value: "createdAtDesc", text: "Created Date (Latest First)" },
  { key: "createdAtAsc", value: "createdAtAsc", text: "Created Date (Oldest First)" },
  { key: "nameAsc", value: "nameAsc", text: "Supplier Name (A-Z)" },
  { key: "nameDesc", value: "nameDesc", text: "Supplier Name (Z-A)" }
];

const productOrderByOptions = [
  { key: "nameAsc", value: "nameAsc", text: "Product Name (A-Z)" },
  { key: "nameDesc", value: "nameDesc", text: "Product Name (Z-A)" },
  { key: "createdAtDesc", value: "createdAtDesc", text: "Created Date (Latest First)" },
  { key: "createdAtAsc", value: "createdAtAsc", text: "Created Date (Oldest First)" },
  { key: "climateAsc", value: "climateAsc", text: "Climate Impact (Lowest First)" },
  { key: "climateDesc", value: "climateDesc", text: "Climate Impact (Highest First)" }
];

const supplierDisplayOnlyOptions = [
  { key: "all", value: "all", text: "All" },
  { key: "user", value: "user", text: "Supplier as User" },
  { key: "notUser", value: "notUser", text: "Not Users" }
];

const SupplierTypeLabel = {
  Internal: "In-House",
  External: "External"
};

const staticSuppliers = [
  { id: 0, title: "+ New" },
  { id: 1, title: "In-house supplier" }
];

const staticChemicalSuppliers = [{ id: 0, title: "+ New" }];

const staticChemical = { id: 0, title: "+ New Chemical" };

const DEFAULT_TRANSPORT_TYPE = "1";
const DISABLE_REVIEW_BUTTON = FEATURE_FLAGS.DisableReview;
const DISABLE_COMPANY_LIST_CREATE_ON_COLUMN = FEATURE_FLAGS.DisableCompanyListCreateOnColumn;
const DISABLE_IS_ROOT_PRODUCT_BUTTON = FEATURE_FLAGS.DisableIsRootProductButton;
const DISABLE_SIMULATION_INGREDIENT_DETAILS = FEATURE_FLAGS.DisableSimulationIngredientDetails;
const DISABLE_FACILITY_SIMULATION = FEATURE_FLAGS.DisableFacilitySimulator;
const ProcessBestPracticeHeader = [
  { id: "energy", title: "Energy (Power & Heat)", icon: Zap, color: "energy" },
  { id: "waste", title: "Waste", icon: Trash2, color: "waste" },
  { id: "water", title: "Water", icon: Droplet, color: "water" },
  { id: "chemicals", title: "Chemicals", icon: FlaskConical, color: "chemicals" },
  {
    id: "yield",
    title: "Yield",
    icon: TrendingUp,
    color: "yield"
  }
];

const TempWaterData = {
  results: {
    waste: [
      {
        processId: "65724d87cf878d56e2cc76e1",
        process: "Mechanical selection for sorting",
        type: "Damaged, undersized, or defective fruits",
        quantity_kg: "1000",
        quantity_percent: "5.0% of input",
        notes: "Mechanical sorting rejects; potential for secondary processing or animal feed"
      },
      {
        processId: "65724df8cf878d56e2cc76f7",
        process: "Conveyor belt for manual selection for sorting",
        type: "Manually rejected fruits (decay, quality defects)",
        quantity_kg: "500",
        quantity_percent: "2.6% of input",
        notes: "Visual quality control rejects; combined sorting waste is 7.5% of raw material"
      },
      {
        processId: "6572f0d9cf878d56e2cc7b7a",
        process: "Juice extraction",
        type: "Citrus peel, seeds, and membranes",
        quantity_kg: "8500",
        quantity_percent: "45.9% of input",
        notes:
          "Largest waste stream; high-value potential for pectin, essential oils, animal feed, and biogas"
      },
      {
        processId: "6572f15fcf878d56e2cc7ba6",
        process: "Straining step 1",
        type: "Pulp and fiber residue",
        quantity_kg: "600",
        quantity_percent: "6.0% of input",
        notes:
          "Coarse pulp separation; contains valuable fiber for dietary supplements or animal feed"
      },
      {
        processId: "6572f1b0cf878d56e2cc7beb",
        process: "Straining step 3",
        type: "Fine pulp and fiber residue",
        quantity_kg: "500",
        quantity_percent: "25.0% of input",
        notes:
          "Fine straining residue; high fiber content suitable for drying and food ingredient applications"
      },
      {
        processId: "6572f282cf878d56e2cc7c43",
        process: "Sinking the pulp adjustment",
        type: "Excess pulp removed for clarity",
        quantity_kg: "300",
        quantity_percent: "3.0% of input",
        notes:
          "Pulp removed to achieve desired juice clarity; can be recovered for pulpy juice products"
      },
      {
        processId: "6572f58bcf878d56e2cc7ca0",
        process: "Pasteurization",
        type: "Thermal processing loss (evaporation and adhered product)",
        quantity_kg: "400",
        quantity_percent: "4.1% of input",
        notes:
          "Combination of evaporation and equipment holdup; optimize with heat recovery and CIP protocols"
      },
      {
        processId: "6572f667cf878d56e2cc7cd1",
        process: "Machine: Aseptic processing for DRUM Filling",
        type: "Product spillage and line purging waste",
        quantity_kg: "200",
        quantity_percent: "2.2% of input",
        notes: "Filling line waste during startup, shutdown, and changeover"
      },
      {
        processId: "6572f6b6cf878d56e2cc7cf1",
        process: "Aseptic processing for DRUM Filling",
        type: "Product spillage and line purging waste",
        quantity_kg: "200",
        quantity_percent: "2.2% of input",
        notes: "Second filling line with identical waste characteristics"
      }
    ],
    actions: [
      {
        processId: "6572f0d9cf878d56e2cc7b7a",
        category: "Waste valorization",
        priority: 10,
        description:
          "Implement integrated citrus waste valorization system: (1) Cold-press extraction of essential oils from peel (0.5-1.5% recovery rate), (2) Pectin extraction from albedo using acid/heat treatment (15-25% of peel dry weight), (3) Drying of remaining residue for cattle/poultry feed. Install extraction equipment, pectin recovery tanks, and drum dryer system.",
        expected_reduction_percent:
          "0% physical waste reduction, but 100% valorization of 8,500 kg waste into revenue: ~85-128 kg essential oils, ~320-640 kg pectin, ~6,800-7,100 kg dried feed",
        expected_revenue_usd:
          "$15,000-25,000 per batch (essential oils: $5,000-10,000 at $60-80/kg, pectin: $3,000-5,000 at $8-12/kg, feed: $7,000-10,000 at $1.0-1.4/kg)",
        source: "Tetra Pak Citrus Processing Handbook; Industry best practice (to be verified)",
        link: "https://www.tetrapak.com/en-us/processing/citrus-processing",
        trade_offs:
          "Capital investment $150,000-300,000; requires 200-300 m² additional space; skilled labor for quality control; pectin extraction generates acidic wastewater (pH 2-3) requiring neutralization; essential oil storage requires cool, dark conditions; 12-18 month payback period"
      },
      {
        processId: "65724d87cf878d56e2cc76e1",
        category: "Operational adjustment",
        priority: 8,
        description:
          "Optimize mechanical sorter calibration: (1) Adjust optical sensor thresholds based on fruit variety and seasonal characteristics, (2) Implement weekly calibration protocol using control samples, (3) Install secondary inspection station for borderline rejects with 15-minute buffer time, (4) Divert recoverable fruit to juice processing and unusable fruit to valorization stream rather than disposal.",
        expected_reduction_percent:
          "30-50% reduction in mechanical sorting waste (300-500 kg saved per batch), recovering product worth $300-500",
        expected_revenue_usd:
          "$150-250 per batch from recovered fruit at $0.50/kg juice equivalent",
        source: "Industry best practice (to be verified)",
        link: "N/A",
        trade_offs:
          "Requires 2-4 hours technician time weekly for calibration; secondary inspection adds 0.5 FTE labor cost (~$15,000/year); risk of quality degradation if tolerance set too high; requires documented SOP and quality acceptance criteria"
      },
      {
        processId: "6572f15fcf878d56e2cc7ba6",
        category: "Waste valorization",
        priority: 9,
        description:
          "Recover pulp waste from straining operations (combined 1,100 kg from steps 1 and 3) by installing drum dryer and hammer mill to produce citrus fiber powder. Product specifications: 50-70% total dietary fiber, moisture <8%, suitable for bakery applications, beverage clouding, and dietary supplements. Market value $2-4/kg for food-grade citrus fiber.",
        expected_reduction_percent:
          "90% volume reduction through drying; convert 1,100 kg wet pulp (12-15% solids) to ~150-200 kg dried fiber powder",
        expected_revenue_usd:
          "$400-800 per batch; annual revenue potential $50,000-100,000 (assuming 125 batches/year)",
        source: "Industry best practice (to be verified)",
        link: "N/A",
        trade_offs:
          "Drum dryer capital cost $40,000-80,000; energy consumption 50-100 kWh per batch ($5-15); requires food-grade handling certification; packaging costs $0.50-1.00/kg; must meet dietary fiber specifications (AOAC methods); storage requires dry conditions (<60% RH)"
      },
      {
        processId: "6572f58bcf878d56e2cc7ca0",
        category: "Retrofit",
        priority: 7,
        description:
          "Install plate heat exchanger (PHE) with heat recovery system for pasteurization: (1) Capture 60-70% of thermal energy for pre-heating incoming juice, (2) Optimize flow velocity to reduce product holdup in dead zones, (3) Implement enhanced CIP protocol with product recovery rinse cycle before cleaning, (4) Install level sensors to minimize product loss during batch transitions.",
        expected_reduction_percent:
          "25-35% reduction in pasteurization losses (100-140 kg saved per batch)",
        expected_revenue_usd:
          "$100-140 per batch from recovered product; additional $50-80/batch energy savings from heat recovery",
        source:
          "ISO 14001:2015 Environmental management systems; Industry best practice (to be verified)",
        link: "https://www.iso.org/standard/60857.html",
        trade_offs:
          "PHE retrofit $30,000-60,000; installation downtime 3-5 days; increased water usage for recovery rinse (+200-300 liters/batch); CIP cycle extended by 15-20 minutes; requires process validation for food safety; heat recovery effectiveness varies with production schedule"
      },
      {
        processId: "6572f282cf878d56e2cc7c43",
        category: "Operational adjustment",
        priority: 6,
        description:
          "Install inline Brix and pulp content monitoring with automated control system to optimize pulp removal: (1) Real-time adjustment of centrifuge speed based on target specifications, (2) Redirect excess pulp to dedicated 2,000L storage tank, (3) Create 'pulpy juice' product variant (10-15% pulp vs. 5-8% standard) for market differentiation, (4) Blend recovered pulp back into lower-grade products rather than waste.",
        expected_reduction_percent:
          "60-80% reduction in pulp adjustment waste (180-240 kg saved per batch)",
        expected_revenue_usd:
          "$200-300 per batch from pulpy juice product line (premium pricing) or $90-120 from lower-grade product blending",
        source:
          "Equipment manufacturer guidelines (to be verified); Industry best practice (to be verified)",
        link: "N/A",
        trade_offs:
          "Inline monitoring and control system $15,000-25,000; stainless steel storage tank $10,000-12,000; pulpy juice has 25-30% shorter shelf life (60-75 days vs. 90 days) requiring faster inventory turnover; additional SKU complexity; requires consumer acceptance testing"
      },
      {
        processId: "6572f667cf878d56e2cc7cd1",
        category: "Operational adjustment",
        priority: 7,
        description:
          "Optimize aseptic filling operations across both lines (combined 400 kg waste): (1) Install automated startup sequencing to reduce purge volume by 40%, (2) Implement product recovery system with holding tank for changeover product (sterile conditions), (3) Establish predictive maintenance program to reduce unplanned stops by 60%, (4) Develop operator training program on waste-minimizing procedures with performance KPIs.",
        expected_reduction_percent:
          "40-60% reduction in filling line waste (160-240 kg saved across both lines)",
        expected_revenue_usd: "$160-240 per batch from recovered product at $1.00/kg juice value",
        source:
          "Industry best practice (to be verified); Equipment manufacturer guidelines for aseptic systems (to be verified)",
        link: "N/A",
        trade_offs:
          "Automation upgrade $20,000-40,000; product recovery system $15,000-25,000; requires regulatory validation for aseptic recovery protocol; operator training time 40 hours ($2,000); recovery tank adds cleaning complexity; startup time may increase by 10-15 minutes during transition period"
      },
      {
        processId: "65724df8cf878d56e2cc76f7",
        category: "Operational adjustment",
        priority: 5,
        description:
          "Improve manual sorting efficiency: (1) Upgrade to LED lighting system (1,000+ lux) with color temperature 5,000-6,500K for better defect visibility, (2) Install ergonomic workstations with adjustable height and anti-fatigue mats, (3) Implement variable belt speed control (reduce 20% during high-defect periods), (4) Develop visual training program with photo standards for borderline fruit, (5) Establish 'secondary use' protocol for cosmetically imperfect but safe fruit.",
        expected_reduction_percent:
          "20-30% reduction in manual sorting waste (100-150 kg saved per batch)",
        expected_revenue_usd: "$50-75 per batch from recovered fruit",
        source: "Industry best practice (to be verified)",
        link: "N/A",
        trade_offs:
          "Workstation upgrade $5,000-10,000; LED lighting retrofit $3,000-5,000; variable speed drive $2,000-3,000; slower belt speed reduces throughput 5-10% during defect periods; requires quality management system documentation; training time 16 hours per sorter"
      },
      {
        processId: "6572f0d9cf878d56e2cc7b7a",
        category: "Retrofit",
        priority: 8,
        description:
          "Upgrade to modern high-efficiency juice extractor system (e.g., in-line extraction with pressure-controlled cups): (1) Improved pressure profiling reduces peel oil contamination while increasing yield, (2) Better separation technology with dual-stage extraction, (3) Automated cup adjustment for fruit size variation, (4) Integration with peel valorization system. Modern systems achieve 5-8% higher juice recovery compared to conventional extractors.",
        expected_reduction_percent:
          "5-8% increase in juice yield (reducing relative peel waste by 900-1,400 kg while increasing juice output by same amount, from 10,000 kg to 10,900-11,400 kg)",
        expected_revenue_usd:
          "$900-1,400 per batch from additional juice at $1.00/kg (partially offset by reduced peel valorization volume reducing that revenue by $300-450)",
        source: "Equipment manufacturer guidelines (to be verified)",
        link: "N/A",
        trade_offs:
          "Major capital investment $250,000-500,000; installation requires 2-4 weeks production downtime; higher maintenance complexity and parts cost (+$15,000-25,000/year); requires specialized technician training; reduced peel volume decreases valorization revenue by $300-450/batch; increased cleaning requirements (15-20% longer CIP cycles)"
      },
      {
        processId: "6572f00ccf878d56e2cc7af6",
        category: "Operational adjustment",
        priority: 9,
        description:
          "Implement comprehensive water recycling system for washing processes (total 11 m³/kg across alkaline wash 3 m³/kg and final rinse 6 m³/kg): (1) Install multi-stage filtration (100μm screen, sand filter, activated carbon), (2) Implement counter-current washing to reduce fresh water 60-75%, (3) Recycle alkaline wash water with NaOH top-up instead of full replacement, (4) Install conductivity and turbidity monitoring for water quality control, (5) Segregate final rinse water for reuse in initial wash stages.",
        expected_reduction_percent:
          "60-75% reduction in fresh water consumption (6.6-8.25 m³/kg saved); proportional reduction in wastewater generation",
        expected_revenue_usd:
          "$300-500 per batch in combined water supply and wastewater treatment savings (water: $2-3/m³, wastewater: $3-5/m³)",
        source:
          "ISO 14046:2014 Water footprint principles; Industry best practice (to be verified)",
        link: "https://www.iso.org/standard/43263.html",
        trade_offs:
          "Water treatment system capital cost $80,000-150,000; ongoing maintenance $5,000-8,000/year; chemical treatment for microbial control $50-100/batch; requires continuous water quality monitoring (turbidity <50 NTU, microbial limits); filter replacement $3,000-5,000/year; system cleaning and sanitization adds 2-3 hours weekly"
      },
      {
        processId: "6572f0d9cf878d56e2cc7b7a",
        category: "Waste valorization",
        priority: 6,
        description:
          "Install anaerobic digestion system for residual citrus waste (after essential oil and pectin recovery): (1) Pre-treatment to remove limonene (digestion inhibitor) via steam distillation or adsorption, (2) Mesophilic digestion at 35-40°C with 25-35 day hydraulic retention time, (3) Biogas production 0.3-0.5 m³/kg volatile solids (typically 15-20% of wet peel weight), (4) Use biogas for facility heating and electricity via CHP unit, (5) Utilize digestate as liquid fertilizer or compost feedstock.",
        expected_reduction_percent:
          "Processes 100% of residual peel waste after other valorization; produces 1,500-2,500 m³ biogas per batch (60-65% methane content)",
        expected_revenue_usd:
          "$450-750 per batch in energy value (biogas: $0.25-0.30/m³ equivalent) plus digestate fertilizer value $200-300/batch",
        source: "Industry best practice (to be verified)",
        link: "N/A",
        trade_offs:
          "Major capital investment $200,000-400,000 for 50-100 m³ digester and CHP unit; long retention time requires large tank volume; limonene pre-treatment adds complexity and cost ($50-80/batch); digestate requires storage (6-12 months) and distribution logistics; system startup time 8-12 weeks; requires skilled operator; odor management system necessary"
      },
      {
        processId: "ALL_PROCESSES",
        category: "Operational adjustment",
        priority: 10,
        description:
          "Establish comprehensive waste tracking and continuous improvement system: (1) Install mass flow meters and loss-in-weight scales at each process step, (2) Implement real-time dashboard (SCADA/MES integration) displaying waste by type, process, shift, and batch, (3) Calculate and display mass balance closure (target >95%) to identify unmeasured losses, (4) Set KPI targets: 10% year-over-year waste reduction, <2% unaccounted losses, (5) Implement shift-level accountability with performance reporting, (6) Establish monthly Kaizen events focused on top waste sources, (7) Create operator incentive program tied to waste reduction achievements.",
        expected_reduction_percent:
          "5-15% overall waste reduction through visibility and accountability across all processes; enables data-driven identification of specific improvement opportunities worth additional 3-8% reduction",
        expected_revenue_usd:
          "$1,000-3,000 per batch through combined optimization effects (reduced raw material losses, improved yield, better scheduling)",
        source:
          "ISO 14001:2015 Environmental management systems; Industry best practice (to be verified)",
        link: "https://www.iso.org/standard/60857.html",
        trade_offs:
          "Software and sensor system capital cost $25,000-50,000; annual software licensing $3,000-5,000; requires cultural change management and leadership commitment; ongoing data analysis time 10-15 hours/week ($25,000-35,000/year FTE cost); potential employee resistance requiring change management; 3-6 month implementation timeline; benefits accumulate over 12-24 months"
      },
      {
        processId: "6572f1b0cf878d56e2cc7beb",
        category: "Operational adjustment",
        priority: 4,
        description:
          "Optimize straining step 3 parameters to reduce fiber loss while maintaining juice quality: (1) Test variable screen aperture sizes (0.3-0.5mm range) to find optimal balance between yield and quality, (2) Adjust pressure differential (reduce from typical 3-4 bar to 2-3 bar) to minimize fiber breakdown, (3) Implement pulsed flow regime to reduce screen blinding and improve throughput, (4) Install automated screen cleaning system (backflush every 15-20 minutes) to maintain consistent separation.",
        expected_reduction_percent:
          "10-20% reduction in straining waste (50-100 kg saved from step 3); improved juice recovery offsets fiber loss",
        expected_revenue_usd: "$50-100 per batch from improved juice yield",
        source:
          "Industry best practice (to be verified); Equipment manufacturer guidelines (to be verified)",
        link: "N/A",
        trade_offs:
          "Screen replacement testing $2,000-3,000; automated cleaning system retrofit $8,000-15,000; requires juice quality validation (particle size distribution, cloud stability testing); may affect juice mouthfeel requiring sensory evaluation; increased maintenance attention to screen condition; backflush increases water usage by 100-200 L/batch"
      }
    ],
    top_priorities: [
      {
        action_index: 10,
        reason:
          "FOUNDATIONAL PRIORITY: Waste tracking and KPI system (action index 10) requires lowest capital investment ($25,000-50,000) but enables all other improvements through data visibility. Expected 5-15% waste reduction ($1,000-3,000/batch) through accountability alone, plus identifies specific high-value opportunities. This creates the management foundation and baseline measurement essential for justifying and measuring all subsequent investments. Should be implemented first (months 1-3) before any other major capital projects."
      },
      {
        action_index: 0,
        reason:
          "HIGHEST VALUE OPPORTUNITY: Citrus peel valorization (action index 0) addresses the largest waste stream (8,500 kg, 45.9% of total waste) and offers exceptional revenue potential ($15,000-25,000 per batch, $1.875-3.125 million annually at 125 batches). While capital-intensive ($150,000-300,000), the 12-18 month payback and proven technology make this compelling. Transforms the facility's largest cost center into a profit center. Implement after waste tracking system is operational (months 4-9) to establish baseline and validate business case."
      },
      {
        action_index: 2,
        reason:
          "QUICK WIN WITH STRONG ROI: Pulp fiber recovery (action index 2) offers excellent value with moderate investment ($40,000-80,000 dryer system) and 6-12 month payback. Addresses 1,100 kg waste (10% of total) with proven technology producing high-value food ingredient ($400-800/batch, $50,000-100,000 annual revenue). Simpler operation than peel valorization with less technical risk. Implement in parallel with or immediately after peel valorization system (months 6-12) as both create complementary revenue streams from different waste fractions."
      }
    ]
  },
  summary: "```json\n\n```"
};

const CULTIVATION_LABEL_TYPE = {
  GenericUser: "Generic/User",
  Fertilizer: "Fertilizer",
  Pesticide: "Pesticide",
  LandUseChange: "Land use change"
};

const VARIATION_NAME_MAX_LENGTH = 15;

const DISABLE_BOM_CHEMICAL = FEATURE_FLAGS.DisableBOMChemical;
const DISABLE_COGNITO_LOGIN = FEATURE_FLAGS.DisableCognitoLogin;
const DISABLE_COMMERCIAL_CHEMICAL = FEATURE_FLAGS.DisableCommercialChemical;
const DISABLE_SEMI_SPECIFIC_COOLING = FEATURE_FLAGS.DisableSemiSpecificCooling ?? false;
const DISABLE_PRODUCT_REVIEW_NEW = FEATURE_FLAGS.DisableProductReviewNew ?? false;
const ENABLE_NEW_RECIPE_SIMULATION = FEATURE_FLAGS.EnableNewRecipeSimulation ?? false;
const ENABLE_ADD_INGREDIENT_DIALOG_REDESIGN =
  FEATURE_FLAGS.EnableAddIngredientDialogRedesign ?? false;
const ENABLE_EXTERNAL_TRANSPORT_TOOL = FEATURE_FLAGS.ExternalTransportToolEnabled ?? false;
const ENABLE_IMPACT_RESULT_DOCUMENTS = FEATURE_FLAGS.EnableImpactResultDocuments ?? false;

const IDLE_TIME = 480;
const WARNING_TIME = 2;
const DENMARK_COUNTRY_CODE = "47";
const DEFAULT_CHEMICAL = "1";

// Pagination
const PAGINATION_ITEMS_PER_PAGE = 5;

const FOCUS_RING_CLASS =
  "focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2";

export {
  API_URL,
  calculationStatus,
  CHEMICAL_TAB_KEYS,
  ChemicalViewTabs,
  COMMON_PROTECT_ROUTE_PATH,
  COMPANY_LOGO,
  COMPANY_NAME,
  CULTIVATION_LABEL_TYPE,
  CULTIVATION_TYPE,
  customButtonUpdatetitle,
  customOptionSupplier,
  CycleStage,
  DEFAULT_CHEMICAL,
  DEFAULT_COUNTRY_CODE,
  DEFAULT_TRANSPORT_TYPE,
  DENMARK_COUNTRY_CODE,
  DISABLE_BEST_PRACTICE,
  DISABLE_BOM_CHEMICAL,
  DISABLE_CLOSE_MODEL_ID,
  DISABLE_COGNITO_LOGIN,
  DISABLE_COMMERCIAL_CHEMICAL,
  DISABLE_COMPANY_LIST_CREATE_ON_COLUMN,
  DISABLE_FACILITY_SIMULATION,
  DISABLE_IS_ROOT_PRODUCT_BUTTON,
  DISABLE_RECIPE_SIMULATOR,
  DISABLE_REVIEW_BUTTON,
  DISABLE_SEMI_SPECIFIC_COOLING,
  DISABLE_SIMULATION_INGREDIENT_DETAILS,
  drawerRoute,
  EMAIL_ADDRESS,
  ENABLE_ADD_INGREDIENT_DIALOG_REDESIGN,
  ENABLE_EXTERNAL_TRANSPORT_TOOL,
  ENABLE_IMPACT_RESULT_DOCUMENTS,
  ENABLE_NEW_RECIPE_SIMULATION,
  FarmGateReviewTabs,
  FertilizerNameData,
  FOCUS_RING_CLASS,
  GateType,
  HarvestSeasonData,
  HEADER_MENU_BAR,
  IDLE_TIME,
  IMPACT_CATEGORY,
  ImpactAssessmentMethodText,
  IngredientImpact,
  IngredientViewTabs,
  LcalCulculationDefultValues,
  MAPBOX_ACCESS_TOKEN,
  MAPBOX_BASE_API_URL,
  MAPBOX_TOKEN,
  MAPBOX_V5_API_URL,
  MappingInteractionStatus,
  MappingReviewTabs,
  MENU_SIDE_BAR,
  modelContentType,
  NEW_FACILITY_KEY,
  newChemical,
  NewFacilityOption,
  newNodes,
  newSupplier,
  noResultIngredient,
  NOT_APPLICABLE,
  NoteDocumentTable,
  NotificationTableCok,
  NP_API_URL,
  NP_CALCULATOR_API_URL,
  NP_SOCKET_API_URL,
  PACKAGE_TYPES,
  packagingFieldMap,
  PAGINATION_ITEMS_PER_PAGE,
  ProcessBestPracticeHeader,
  ProcessGateReviewTabs,
  PRODUCT_TAB_KEYS,
  ProductFilterData,
  productOrderByOptions,
  ProductSummaryButtonAverageProduct,
  ProductSummaryTitle,
  ProductTableContent,
  ProductViewTabs,
  proOptionsForReactFlow,
  SimulationDataTable,
  SimulationImpactFarm,
  SimulationImpactProcess,
  SimulationNetZeroDataTable,
  SipContents,
  staticChemical,
  staticChemicalSuppliers,
  staticSuppliers,
  SUPPLIER_DEFAULT_COUNTRY_GLOBAL,
  SupplierClientRequestTab,
  supplierDisplayOnlyOptions,
  supplierOrderByOptions,
  SupplierRequestStatus,
  SupplierTypeLabel,
  switchSize,
  TAB_KEYS,
  TempWaterData,
  THEME,
  UserFilterData,
  VARIATION_NAME_MAX_LENGTH,
  WARNING_TIME,
  WEB_VERSION,
  DISABLE_PRODUCT_REVIEW_NEW
};

export * from "./optionsConstants";
export * from "./tableColConstant";

// data type options
export const dataTypeOptions: DropdownOption[] = [
  { key: 1, value: IngredientDataTypesOption.SPECIFIC, text: "Specific" },
  { key: 2, value: IngredientDataTypesOption.GENERIC, text: "Generic" }
];

// recipe data type options
export const recipeDataTypeOptions: DropdownOption[] = [
  { key: 1, value: RecipeDataTypesOption.SPECIFIC, text: "Specific" },
  { key: 2, value: RecipeDataTypesOption.GENERIC, text: "Generic" },
  { key: 3, value: RecipeDataTypesOption.SEMI_SPECIFIC, text: "Semi Specific" }
];

// storage env type options
export const storageEnvTypeOptions: DropdownOption[] = [
  { key: 1, value: StorageEnvType.AMBIENT, text: "Ambient" },
  { key: 2, value: StorageEnvType.COOLING, text: "Cooling" },
  { key: 3, value: StorageEnvType.FREEZING, text: "Freezing" }
];

export const fixedColumns = [
  { name: "ingredient", title: "Ingredient Name", mainContent: true },
  { name: "original", title: "Original Recipe (%)", mainContent: true }
];

export const filterFacilityTypesKey = "currentFilterFacilityTypes";

//tailwind const value
